import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemChecklist, BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function SystemOverview() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-144" data-mp="18tg25oet4yhn">
      <div className="mx-auto max-w-2xl text-center" data-id="element-145" data-mp="1mlch0qrgtbw3">
        <h2 className="font-heading text-[1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.45rem]" data-id="element-146" data-mp="1hnknxtf33jqb">
          The Complete 6-in-1 Cleaning Business System
        </h2>
        <p className="mt-0.5 font-heading text-[1.25rem] font-extrabold uppercase leading-tight text-brightblue sm:text-[2rem]" data-id="element-147" data-mp="tztdywh0nis7">
          🧹 Cleaning Ready™
        </p>
        <p className="mt-0.5 font-heading text-[0.68rem] font-bold uppercase tracking-[0.1em] text-gold sm:text-xs" data-id="element-148" data-mp="13xqzvdbel3hn">
          Ready-to-use tools for cleaning professionals
        </p>
        <p className="mt-0.5 text-[0.68rem] font-medium text-muted sm:text-[0.8rem]" data-id="element-149" data-mp="2fa1l8ynthxc2">
          Clients • Services • Quotes • Scheduling • Communication • Operations
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-1.5 block" data-id="element-150" data-mp="2375p385x4gz3">
          <img src={BOX_IMAGE} alt="The six modules of the CLEANING READY™ system" className="mx-auto w-full max-w-[200px] sm:max-w-[250px]" data-id="element-151" data-mp="238qj8woblxwf" />
        </a>

        <ul className="mt-1.5 grid grid-cols-1 gap-x-4 gap-y-0.5 text-left sm:grid-cols-2" data-id="element-152" data-mp="2d2pkltgkldnb">
          {systemChecklist.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-153" data-mp="1kgnzhcgdu1hy">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-confirm" strokeWidth={3.5} aria-hidden="true" data-id="element-154" data-mp="1pez8xm2rm9zn" />
              <span className="text-[0.8rem] leading-[1.35] text-navy sm:text-[0.95rem]" data-id="element-155" data-mp="1ubzfdy3j1era">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}